<template>
<div>
    <div class="topbar">
      <i @click="goHome"></i>
      <!-- <span>{{$t('nav_name')}}</span> -->
      <div class="mainBox1">
        <div class="changeLangBtn" @click.stop="moreLang()">
          {{ $t("language") }}
          <em class="iconfont icon-een"></em>
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li v-for="(item,index) in langList" class="chooseLangUlli" :key="index" @click="setLanguage(item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="changeLangBtn1" @click.stop="goLogin()">{{$t('homepage_button1')}}</div>
      </div>
    </div>
    <div class="banner">
      <div class="forget">
        <div class="forgetPsd">{{$t('signin_txt3')}}</div>
        <span class="email">{{$t('forPass_txt1')}}</span>
        <!-- email !phoneShow-->
        <div class="inputItem clearfix" v-if="false">
          <span class="account">{{$t('signin_txt1')}}</span>
          <input v-model="email" type="text" dir="ltr" @blur="checkEmail" @focus="checkEmail1" @keyup.enter="check">
          <span v-if="forgetShow" v-text="emailShowtext" class="s1" >{{$t('signup_txt13')}}</span>
          <div class="yanz" @click="check">{{$t('forPass_txt3')}}</div>
        </div>
        <!-- radio radioShow-->
        <div style="font-size: 20px;color: #fff;cursor: pointer;width: 500px; margin: 0 auto;height: 25px;" v-if="false">
          <label style="cursor:pointer;float:left;margin-left:76px;margin-top:15px;">
            <input style="width:15px;height:15px;display:inline-block; margin-right:5px;" name="gender" type="radio" value="1" checked @click='checkPone'/>手机号
          </label>
          <label style="cursor:pointer;float:right;margin-right:76px;margin-top:15px;">
            <input style="width:15px;height:15px;display:inline-block; margin-right:5px;" name="gender" type="radio" value="2" @click='checEmail'/>邮箱
          </label>
        </div>
        <!-- v-if="allPhoneShow" -->
       <div >
          <!-- phone -->
          <div class="inputItem clearfix">
            <span class="account">{{$t('signin_txt1')}}</span>
            <input v-model="phone" dir="ltr" type="text" @blur="checkphone" @focus="checkEmail1">
            <span v-if="forgetShow" v-text="emailShowtext" class="s1 s2" >{{$t('signup_txt13')}}</span>
          </div>
          <!-- phoneCode -->
          <div class="inputItem clearfix">
            <span class="account">{{$t('signup_txt10')}}</span>
            <input type="text" dir="ltr" v-model.trim="phoneCode" style="padding-right:118px;width:235px" @blur="checkphoneCode" @focus="checkphoneCode1"  @keyup.enter="check11">
            <button @click="getMsg" id="buttonMsg" >{{$t('signup_txt11')}}</button>
            <span v-show="show7" class="s1">{{$t('signup_note15')}}</span>
            <div class="yanz" @click="check11">{{$t('forPass_txt3')}}</div>
          </div>
       </div>
        <!-- email -->
        <div class="inputItem clearfix" v-if="checkeamilShow">
          <span class="account">邮箱</span><input v-model="zhEmail" type="text" dir="ltr"  @blur="checkzhEmail" @focus="checkEmail1" @keyup.enter="check">
          <span v-if="forgetShow" v-text="emailShowtext" class="s1" >{{$t('signup_txt13')}}</span>
          <div class="yanz" @click="check">{{$t('forPass_txt3')}}</div>
        </div>
        <div class="send" v-show="allMsg" v-text="warinningText">
        </div>
      </div>
    </div>
</div>
</template>

<script>
import I18nUtils from "@/utils/i18nUtils";

export default {
  name: 'forgotPwd',
  data () {
    return {
      emailShowtext:'',
      radioShow:false,
      phonecodeShow:true,
      forgetShow:false,
      checkeamilShow:false,
      email:'',
      phone:'',
      phoneCode:'',
      zhEmail:'',
      warinningText:'',
      emailReg:false,
      phoneShow:false,
      allPhoneShow:true,
      allMsg:false,
      changeLangBox:false,
      show7Reg:false,
      show7:false,
      langList: I18nUtils.langList,
    }
  },
  mounted () {

    this.getChannel();

    I18nUtils.initLanguage(this);

    this.emailShowtext = this.$t('signup_txt13')
    this.warinningText = this.$t('forPass_win');
  },
  watch: {

  },
  methods: {
    setLanguage(lang) {
      I18nUtils.updateDivLanguage(lang);
      I18nUtils.setLanguage(this, lang);
    },

    getChannel() {
      let args = {};

      const qs =
        window.location.search.length > 0
          ? window.location.search.substr(1)
          : "";

      const itemsArray = qs.length > 0 ? qs.split("&") : [];

      itemsArray.forEach(e => {
        let item = e.split("=");
        let name = decodeURIComponent(item[0]);
        let value = decodeURIComponent(item[1]);

        if (name.length !== 0) {
          args[name] = value;

          if(name == 'channel') {
            sessionStorage.setItem("forget_channel", value)
          }

        }
        return args;
      })
    },

    goLogin(){
      this.$router.push({ path:'/signIn'})
    },
    check(){
      var email = ''
      if(this.$i18n.locale == 'zh'){
        email = this.zhEmail;
      }else{
        email = this.email;
      }
      if(email){
        localStorage.setItem('emailComp',email)
        var userArea = ''
        if(this.$i18n.locale == 'zh'){
          userArea = '1'
        }else if(this.$i18n.locale == 'en'){
          userArea = '2'
        }else if(this.$i18n.locale == 'sp'){
          userArea = '3'
        }else if(this.$i18n.locale == 'fr'){
          userArea = '4'
        }
        this.$http.getAxios('/sms/sendForgetPwdEmail', {
          method: 'post',
          data: {
            'email': email,
            'userArea':userArea
          },
        }).then((res) => {
          var res = res.data;
          if(res.code == '0'){
            this.allMsg = true;
            this.warinningText = this.$t('forPass_win')
          }else if(res.code == '43'){
            this.allMsg = true;
            this.warinningText = this.$t('forPass_note7')
          }else if(res.code == '48'){
            this.allMsg = true;
            this.warinningText = this.$t('forPass_note7')
          }else{
            this.allMsg = true;
            this.warinningText = this.$t('bad_network')
          }

        });
      }else if(this.email == ''){
        this.forgetShow = true;
      }
    },
    checkPone(){
      this.allPhoneShow = true;
      this.checkeamilShow = false;
      this.forgetShow = false

    },
    checEmail(){
      this.checkeamilShow = true;
      this.allPhoneShow = false;
      this.forgetShow = false
    },
    check11(){
      if(this.emailReg && this.show7Reg ){
         this.$http.getAxios('/sms/sendForgetPwdMessage', {
            method: 'post',
            data: {
              'mobile': this.phone,
              'verifyCode':this.phoneCode
            },
          }).then((res) => {
            var res = res.data;
            if(res.code == '0'){
              this.$router.push({ path:'/setPwd'})
              localStorage.setItem("myPhone",this.phone)
              // this.allMsg = true;
              // this.warinningText = this.$t('forPass_win')
            }else if(res.code == '43'){
              this.allMsg = true;
              this.warinningText = this.$t('forPass_note7')
            }else if(res.code == '54'){
              this.allMsg = true;
              this.warinningText = '该手机号绑定多个邮箱账号，请通过邮箱找回密码'
            }else if(res.code == '1'){
              this.allMsg = true;
              this.warinningText = '验证码错误'
            }else{
              this.allMsg = true;
              this.warinningText = this.$t('bad_network')
            }
          });
        }
    },
    goHome(){
      this.$router.push({ path:'/'})
    },
    // 手机号
    checkphone(){
      let reg = /^1[2345789]\d{9}$/
      this.forgetShow = false;
      if(reg.test(this.phone)){
        this.s1Show = false;
        this.emailReg = true;
      }else{
        this.s1Show = true;
        if(this.phone == ''){
          this.emailShowtext = this.$t('signup_txt13')
        }else{
          this.forgetShow = true;
          this.emailShowtext = this.$t('forPass_note2')
        }
      }
    },
    checkzhEmail(){
      this.allMsg = false;
      let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
      if(reg.test(this.zhEmail)){
        this.forgetShow = false;
        this.emailReg = true;
      }else{
        this.forgetShow = true;
        if(this.zhEmail == ''){
          this.emailShowtext = this.$t('signup_txt13')
        }else{
          this.emailShowtext = this.$t('forPass_note2')
        }
      }
    },
    checkphoneCode(){
      let reg = /^[0-9]{6}$/;
      if(reg.test(this.phoneCode)){
        this.show7 = false;
        this.show7Reg = true;
      }else if(this.phoneCode == ''){
        this.show7 = false;
        this.show7Reg = false;
      }else{
        this.show7 = true;
      }
    },
    checkphoneCode1(){
      this.show7 = true;
    },
    // 邮箱验证
    checkEmail(){
      this.allMsg = false;
      let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
      if(reg.test(this.email)){
        this.forgetShow = false;
        this.emailReg = true;
      }else{
        this.forgetShow = true;
        if(this.email == ''){
          this.emailShowtext = this.$t('signup_txt13')
        }else{
          this.emailShowtext = this.$t('forPass_note2')
        }
      }
    },
    getMsg(){
      if(this.phone != '' && this.emailReg ){
        this.forgetShow = false
        this.$http.getAxios('/sms/sendMsg', {
          method: 'post',
          data: {
            'account': this.phone
          },
        }).then((res) => {
          var res = res.data;
          if(res.code == '0'){
          }
          this.start_sms()
        });
      }else{
        this.forgetShow = true
      }
    },
    // 邮箱验证
    checkEmail1(){
      this.forgetShow = true;
      this.allMsg = false;
      this.emailShowtext = this.$t('signup_txt13')
    },
    moreLang(){
      this.changeLangBox = !this.changeLangBox;
    },

    start_sms() {
      var count = 1;
      var sum = 60;
      var that = this
      var i = setInterval(function() {
          if (count > 60) {
              document.getElementById('buttonMsg').removeAttribute('disabled')
              document.getElementById('buttonMsg').innerText = '发送验证码'
              clearInterval(i);
          } else {
              document.getElementById('buttonMsg').setAttribute('disabled',true)
              document.getElementById('buttonMsg').innerText = parseInt(sum - count) + 's';
          }
          count++;
      }, 1000);
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
.topbar{
    width: 100%;
    height: 60px;
    color: #aaf9fe;
    background: #122346;
    i{
      position: absolute;
      top: 8px;
      left: 40px;
      width: 172px;
      height: 46px;
      cursor: pointer;
      z-index: 99999999999999999;
      background: url('~@/assets/images/bigIcon.png') no-repeat center;
    }
}
.topbar span{
    font-size: 20px;
    line-height: 60px;
    margin-left: 100px;
}
.banner{
    width: 1200px;
    margin: 0 auto;
    .forget{
      width: 800px;
      height: 400px;
      position: absolute;
      top:50%;
      left: 50%;
      transform: translate(-50%,-50%);
      text-align: center;
      .send{
        font-size: 20px;
	      color: #ff5a00;
        margin-top: 39px;
        width: 800px;
        text-align: center;
      }
    }
    .forgetPsd{
      margin: 0 auto;
      // width: 453px;
      height: 58px;
      // background: url('~@/assets/images/title.png') no-repeat  center;
      font-size: 38px;
      font-weight: 700;
      line-height: 58px;
      color: #37c2e5;
    }
    .email{
      width: 550px;
      margin: 30px 0;
      font-size: 16px;
      color: #ffffff;
      display: inline-block;
    }

}
.inputItem{
  position: relative;
  text-align: center;
  width: 500px;
  margin: 40px auto;
  input{
    width: 350px;
    padding-left: 154px;
    height: 56px;
    background-color: #ffffff;
    box-shadow: inset 0px 1px 3px 0px
      rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    line-height: 56px;
    font-size: 16px;
    border: 0;
  }
  .s1{
    position: absolute;
    left: 20px;
    bottom: 50px;
    font-size: 14px;
    color: red;
  }
  .s2{
    bottom: -30px;
  }
  ::-webkit-input-placeholder{
    color: #999999;
  }
  :-moz-placeholder{
    color: #999999;
  }
  :-ms-input-placeholder{
    color: #999999;
  }
  .account{
    width: 142px;
    height: 33px;
    position: absolute;
    top:11px;
    line-height: 33px;
    left:0px;
    font-size: 16px;
    color: #010101;
    border-right: 1px solid  #999999;
  }
  .yanz{
    width: 129px;
    height: 53px;
    background-color: #2d8c9e;
    border-radius: 26px;
    opacity: 0.91;
    float: right;
    margin-right: 30px;
    margin-top: 27px;
    font-size: 20px;
	  color: #ffffff;
    text-align: center;
    line-height: 53px;
    cursor: pointer;
  }
}
.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
  }
  .changeLangBtn1{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    line-height: 60px;
    margin-right: 20px;
  }
.chooseLangUl{
    position: absolute;
    z-index: 111;
    li{
      height: 40px;
      cursor: pointer;
    }
  }
.settingBtn,.changeLangBtn{
    cursor: pointer;
    float: right;
    font-weight: normal;
    font-size: 18px;
    padding-right: 20px;
  }
  .mainBox1{
    height: 60px;
    position: absolute;
    top: 0;
    right: 20px;
    z-index: 323223;
}
.inputItem button{
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 16px;
    color: #173ebf;
    cursor: pointer;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    background-color: transparent;
}

input {
  text-indent: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/forgotPwd.vue